<template>
    <div>
        <p class="text-center">Minimum dimensions: {{ minWidth }}x{{ minHeight }}. {{ maxImages - product.images[type].length }} remaining.</p>
        <div class="product-images-existing">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="image in product.images[type]">
                    <div class="d-flex align-items-center">
                        <strong>
                            <a v-bind:href="'https://s3.eu-west-2.amazonaws.com/ngb-mpdb/' + image" target="_blank">{{image}}</a>
                        </strong>

                        <div class="ml-auto" v-if="editable">
                            <b-button type="button" variant="danger" v-on:click="del(type, image)">
                                Remove
                            </b-button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="product-images dropzone" v-bind:class="{'sr-only': !canAddImages(type) || !editable}">
            <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
        </div>
    </div>
</template>

<script>
import Dropzone from 'dropzone'
import lambda from '../lambda'
import Simplert from 'vue2-simplert'
import uuid from 'uuid'

function createImage (name) {
  return uuid.v1() + '/' + name
}

export default {
  name: 'productImages',
  props: ['product', 'type', 'minWidth', 'minHeight', 'defaultMessage', 'maxImages', 'editable'],
  components: {
    Simplert
  },
  methods: {
    del (type, image) {
      for (let i = 0; i < this.product.images[type].length; i++) {
        if (this.product.images[type][i] === image) {
          this.product.images[type].splice(i, 1)
        }
      }
    },
    canAddImages (type) {
      return !this.product.images || !this.product.images[type] || this.product.images[type].length < this.maxImages
    }
  },
  created () {
    if (!this.product.hasOwnProperty('images')) {
      this.product['images'] = {}
    }
    if (!this.product.images.hasOwnProperty(this.type)) {
      this.product.images[this.type] = []
    }
  },
  mounted () {
    const vm = this

    let options = {
      // The URL will be changed for each new file being processing
      url: '/',
      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',
      // Customize the wording
      dictDefaultMessage: this.defaultMessage,
      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,
      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        file.acceptDimensions = () => {
          let name = createImage(file.name)
          lambda.getSignedURL(vm, file, name)
            .then((url) => {
              file.uploadURL = url
              done()
              // Manually process each file
              setTimeout(() => vm.dropzone.processFile(file))
              if (!vm.product.images) {
                vm.product.images = {}
              }
              if (!vm.product.images[vm.type]) {
                vm.product.images[vm.type] = []
              }
              vm.product.images[vm.type].push(name)
            })
            .catch((err) => {
              console.warn(err)
              done('Failed to get an S3 signed upload URL', err)
            })
        }

        file.rejectDimensions = () => {
          vm.$refs.simplert.openSimplert({
            title: 'Invalid image dimensions',
            type: 'info',
            message: 'Please upload an image of at least ' + vm.minWidth + 'x' + vm.minHeight
          })
          this.removeFile(file)
        }
      },
      init () {
        this.on('thumbnail', (file) => {
          if (file.width < vm.minWidth || file.height < vm.minHeight) {
            file.rejectDimensions()
          } else {
            file.acceptDimensions()
          }
        })
      }
    }
    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el.querySelector('.dropzone'), options)
    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ProductImages.vue